import { useEffect } from "react";
import { useThree } from "@react-three/fiber";
import gsap from "gsap";
import useMainContentTab from "../../stores/useMainContentTab.jsx";
import useActiveTabStore from "../../stores/useActiveTab.jsx";

export default function CanvasCamera() {
    const { camera, size } = useThree();
    const { activeTab } = useActiveTabStore();
    const { mainContentTab } = useMainContentTab();

    useEffect(() => {
        console.log("activeTab:", activeTab, "mainContentTab:", mainContentTab);

        const targetMainContentPosition = {
            StartScreen: [0, 0, 50],
            ThankyouScreen: [0, 40, 5],
        };

        const targetActiveTabPosition = {
            Home: [0, 0, 60],
            About: [5, 0, 0.001],
            Projects: [0, 0, 15],
            Skills: [0, 9, 40],
            Contact: [0, 40, 90],
        };

        // Get aspect ratio (width / height)
        const aspect = size.width / size.height;
        let target;

        // If activeTab is defined use that, otherwise use mainContentTab
        if (activeTab && targetActiveTabPosition[activeTab]) {
            target = targetActiveTabPosition[activeTab];
        } else if (mainContentTab && targetMainContentPosition[mainContentTab]) {
            // Adjust ThankyouScreen position dynamically based on aspect ratio:
            if (mainContentTab === "ThankyouScreen") {
                // For more vertical screens, increase the z-value to pull the camera back
                target = aspect < 1 ? [0, 60, 10] : targetMainContentPosition[mainContentTab];
            } else {
                target = targetMainContentPosition[mainContentTab];
            }
        } else {
            target = [0, 0, 40];
        }

        console.log("Animating camera to:", target);

        gsap.to(camera.position, {
            duration: 1.5,
            x: target[0],
            y: target[1],
            z: target[2],
            ease: "sine.inOut",
            onUpdate: () => camera.updateMatrixWorld(),
        });
    }, [activeTab, mainContentTab, camera, size]);

    return null;
}

